jQuery(function ($) {
    var timer = null;

    $(document)
        .on('change', 'input.qty', function () {
            var element = $(this);

            if (timer) {
                clearTimeout(timer);
            }

            timer = setTimeout(function () {
                element.focus().submit()
            }, 300);
        })
        .on('change', '#calc_shipping_postcode, #calc_shipping_country', function () {
            $(this).parents('form').submit();
        })

    function registerCouponToggle() {
        $("#coupon_button")
            .off('click')
            .on('click', function () {
                $("#coupon_field").toggleClass("hidden");
                $("#plusIcon").toggle();
                $("#minIcon").toggle();
            });
    }

    $(document.body).on('wc_fragment_refresh updated_wc_div updated_shipping_method', function () {
        registerCouponToggle();
    });
    registerCouponToggle();

    /**
     * Check if a node is blocked for processing.
     *
     * @param {JQuery Object} $node
     * @return {bool} True if the DOM Element is UI Blocked, false if not.
     */
    var is_blocked = function ($node) {
        return $node.is('.processing') || $node.parents('.processing').length;
    };

    /**
     * Block a node visually for processing.
     *
     * @param {JQuery Object} $node
     */
    var block = function ($node) {
        if (!is_blocked($node)) {
            $node.addClass('processing').block({
                message: null,
                overlayCSS: {
                    background: '#fff',
                    opacity: 0.6
                }
            });
        }
    };

    /**
     * Unblock a node after processing is complete.
     *
     * @param {JQuery Object} $node
     */
    var unblock = function ($node) {
        $node.removeClass('processing').unblock();
    };
});